import {
  type CompanyGroupListItem,
  CompanyGroupMapper,
} from "@/models/company-group.model";
import { getCompanyGroupListPaginated } from "@/spz-api/company-groups/company-groups";
import type { GetCompanyGroupListPaginatedParams } from "@/spz-api/model";
import type { ICompanyGroupRepository } from "../interfaces/company-group-repository.interface";

export class CompanyGroupRepository implements ICompanyGroupRepository {
  async getCompanyGroups(params: GetCompanyGroupListPaginatedParams): Promise<{
    data: CompanyGroupListItem[];
    total: number;
    pageCount: number;
  }> {
    const response = await getCompanyGroupListPaginated(params);
    return {
      data: CompanyGroupMapper.toListItems(response.data),
      total: response.total,
      pageCount: response.pageCount,
    };
  }
}
